module.exports = __webpack_public_path__ + "assets/img/logAudit-module6-5.508b0f5b.jpg";